<template>
  <div>
    <SavCoForm :form="form" :lottie="lottie" @complete="complete" />
  </div>
</template>

<script>
import SavCoForm from "@/components/savco-form";
import form from "./blogger-application";

export default {
  data() {
    return {
      form,
      lottie: {
        src: "assets/lotties/blog-management.json",
        alt: "Standard"
      }
    };
  },
  components: {
    SavCoForm
  },
  methods: {
    complete(dataFromForm) {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss"></style>
